import { graphql } from 'react-relay';

export const VideoGenerationModelsQuery = graphql`
    query videoGenerationModelsQuery {
        videoGenerationModels {
            model
            maxPromptLength
            allowedDurations
            allowedResolutions
            allowedAspectRatios
            supportsGenerateAudio
            isDefault
        }
    }
`;
